export var CHROMECAST_HANDLER_ID="@dicetechnology/doris-handler-chromecast";